import { gql } from "@apollo/client";

export const CREATE_ARTICLE = gql`
  mutation CreateArticleMutation($input: CreateArticleInput!) {
    createArticle(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_ARTICLE = gql`
  mutation UpdateArticleMutation($id: Int!, $input: UpdateArticleInput!) {
    updateArticle(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_ARTICLE = gql`
  mutation RemoveArticleMutation($id: Int!) {
    removeArticle(id: $id) {
      ok
      error
    }
  }
`;

export const ARTICLE = gql`
  query ArticleQuery($id: Int!) {
    article(id: $id) {
      ok
      error
      result {
        id
        customerId
        site
        type
        title
        content
        customer {
          id
          name
        }
      }
    }
  }
`;

export const ARTICLES = gql`
  query ArticlesQuery($where: ArticlesFiltersInput!) {
    articles(where: $where) {
      ok
      error
      total
      results {
        id
        customerId
        site
        type
        title
        content
        customer {
          id
          name
        }
      }
    }
  }
`;
